// extracted by mini-css-extract-plugin
module.exports = {"reactActivityStyle":"_32dTmg3B0h9DdpMgiCo2dm"};